<template>
    <div class="container" style="z-index:1">
        <el-form ref="form" label-width="220px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="申请人姓名">
                        <el-input v-model="personName" placeholder="请输入申请人姓名"  style="width:250px;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="申请人身份证号">
                        <el-input v-model="personCode" placeholder="请输入身份证号码" style="width:250px;"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                <el-form-item label="个人/企业">
                    <el-radio v-model="chooseType" label="1">个人</el-radio>
                    <el-radio v-model="chooseType" label="2">企业</el-radio>
                    <el-button v-show="chooseType==='2'" type="primary" size="mini" @click="openCompanyDialog">选择企业</el-button>
                    <!-- <span v-show="chooseType==='2'" style="margin-left:30px;">{{company}}</span> -->
                </el-form-item>
                </el-col>
                 <el-col :span="8" v-show="chooseType==='2'">
                             <el-form-item label="申请公司名称">
                          <el-input v-model="company" placeholder="请选择或输入" style="width:250px;">
                            </el-input>
                             </el-form-item>
                             </el-col>
                   <el-col :span="8"></el-col>
            </el-row>
            <el-row>

                 <el-col :span="8">
                             <el-form-item label="申请人电话">
                <el-input v-model="phone" placeholder="请输入申请人手机号码" style="width:250px;">
                </el-input>
                             </el-form-item>
                             </el-col>
                   <el-col :span="8">
                    <el-form-item label="用户编号(选填)">
                        <el-input v-model="userId" placeholder="请输入" style="width:250px;"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="8">
                    <el-form-item label="贷款类型">
                        <el-select v-model="loanId" placeholder="选择贷款类型" style="width:250px;">
                            <el-option
                                    v-for="item in loanList"
                                    :key="item.Id"
                                    :label="item.LoanName"
                                    :value="item.Id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="申请额度">
                             <el-input
                             style="width:250px;"
                                 v-model="money"
                                  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                                   placeholder="请输入">
                              </el-input>
                        <span>(万元)</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="选择银行">
                <el-row>
                    <el-select v-model="bank" placeholder="请选择银行">
                        <el-option
                                v-for="item in yjBankList"
                                :key="item.BankID"
                                :label="item.BankName"
                                :value="item.BankID">
                        </el-option>
                    </el-select>
                </el-row>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">提交</el-button>
                <el-button type="normal" @click="onSubmit2">加载</el-button>
            </el-form-item>
        </el-form>
        <el-dialog
                title="选择企业"
                v-model="dialogVisible"
                width="55%" top="6vh">
            <el-table
                    :data="companyList"
                    border
                    max-height="400"
                    style="width: 100%">
                <el-table-column
                        prop="Name"
                        label="公司名称">
                </el-table-column>
                <el-table-column
                        prop="CreditCode"
                        label="统一信用编码"
                        width="350">
                </el-table-column>
                <el-table-column
                        label="操作" width="100">
                    <template #default="scope">
                        <el-button
                                size="mini"
                                type="primary"
                                @click="chooseCompany(scope.row)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @current-change="handlePageChange"
                    :current-page="pageIndex"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="companyTotalCount">
                </el-pagination>
            </div>
        </el-dialog>
        <el-dialog title="加载" v-model="addVisible" width="600px">
                    <div style="width: 560px;text-align: center;">请输入流程编号，将生成新流程并复制用户申请信息</div>
                    <el-input v-model="flowId" style="width: 100px;margin-top: 20px;margin-left: 220px;"></el-input> 
            <template #footer>
                <span class="dialog-footer">
                    <el-button style="margin:0px 10px;" @click="addVisible = false">取消</el-button>
                    <el-button style="margin:0px 10px;" type="primary" @click="addLoanApply2()">提交</el-button>
                </span>
            </template>
        </el-dialog>
    </div>

</template>

<script>
    import indexJs from "./index.js";
    export default indexJs;
</script>

<style scoped>
    .container{
        background-color: rgb(220, 234, 235)!important;
        height: 100%;
        margin:0 auto;
        padding: 50px 50px;
        font-size: 14px;
    }
    .pagination {
        margin: 10px 6px !important;
    }
</style>
